import { jsx } from "react/jsx-runtime";
import { useColorPicker } from "../../../../hooks/useColorPicker.js";
import { outlineWidth } from "../../../Swatch/components/Chip.js";
import { GridLayout } from "./components/GridLayout.js";
function Grid(props) {
  const { children, testId = "Grid" } = props;
  const { swatchesPerRow, swatchesGap } = useColorPicker();
  const maxHeight = typeof props.maxHeight === "number" ? props.maxHeight + outlineWidth * 2 : props.maxHeight;
  return /* @__PURE__ */ jsx(
    GridLayout,
    {
      "data-testid": testId,
      columns: swatchesPerRow,
      padding: `${outlineWidth}px`,
      gap: swatchesGap,
      maxHeight,
      children
    }
  );
}
export {
  Grid
};
//# sourceMappingURL=Grid.js.map
